import React, { useEffect, useLayoutEffect } from "react";
import Footer from "../../../common/components/Footer";
import Auth from "../Auth";
import "./Login.scss";
import WhiteLogo from "../../../assets/logo-white.png";
import { Button } from "antd";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { compose } from "recompose";
import { useSelector, useDispatch } from "react-redux";
import routeActions from "../../../router/redux/actions";

const LogIn = ({ authUser, history }) => {
  const toPage = useSelector((state) => state.routes.toPage);
  const { dispatch } = useDispatch();

  useEffect(() => {
    if (authUser) {
      history.push("/s2r");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    return () => {
      if (toPage) {
        history.push(toPage);
      }
      return () => {
        return () => {
          dispatch(routeActions.toPage(null));
        };
      };
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="loginpage-container-mobile">
        <div className="row landing-nav-bar">
          <Link to="/">
            <img alt="logo" src={WhiteLogo} />
          </Link>
          <Link to="/signin">
            <Button className="sign-up-btn" type="primary">
              Sign up
            </Button>
          </Link>
          <Link to="/signin">
            <p>Log in</p>
          </Link>
        </div>
        <div className="row">
          <div className="col s12 m12 l12 login-container-mobile">
            <div className="auth-area ">
              <Auth />
            </div>
          </div>
        </div>
        <div className="footer-container">
          <Footer />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUser: state.session.authUser,
});

export default compose(withRouter, connect(mapStateToProps))(LogIn);
